var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-form",
    {
      ref: "detailForm",
      attrs: {
        model: _vm.detail,
        disabled: !_vm.canEdit,
        rules: _vm.rules,
        "label-width": "100px",
        "label-position": _vm.device === "mobile" ? "top" : "right",
      },
    },
    [
      _c(
        "el-collapse",
        {
          staticClass: "el-card-collapse",
          model: {
            value: _vm.activeCollapses,
            callback: function ($$v) {
              _vm.activeCollapses = $$v
            },
            expression: "activeCollapses",
          },
        },
        [
          _c(
            "el-collapse-item",
            { attrs: { title: "基本信息", name: "Basic" } },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { xs: 24, md: 10 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "所属商家", prop: "shopName" } },
                        [
                          _vm.canEdit
                            ? _c("el-input", {
                                attrs: { placeholder: "请输入所属商家" },
                                model: {
                                  value: _vm.detail.shopName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.detail, "shopName", $$v)
                                  },
                                  expression: "detail.shopName",
                                },
                              })
                            : _c("span", { staticClass: "el-input" }, [
                                _vm._v(_vm._s(_vm.detail.shopName)),
                              ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { xs: 24, md: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "inline-form-item",
                          attrs: { label: "优惠抵扣" },
                        },
                        [
                          _vm.canEdit
                            ? _c(
                                "el-input",
                                {
                                  staticClass: "max-width",
                                  attrs: {
                                    type: "number",
                                    placeholder: "优惠抵扣",
                                  },
                                  model: {
                                    value: _vm.detail.discount,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.detail, "discount", $$v)
                                    },
                                    expression: "detail.discount",
                                  },
                                },
                                [
                                  _c("template", { slot: "append" }, [
                                    _vm._v("%"),
                                  ]),
                                ],
                                2
                              )
                            : _c(
                                "span",
                                { staticClass: "el-input max-width" },
                                [_vm._v(_vm._s(`${_vm.detail.discount} %`))]
                              ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { xs: 24, md: 16 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品名称", prop: "productName" } },
                        [
                          _vm.canEdit
                            ? _c("el-input", {
                                attrs: { placeholder: "请输入商品名称" },
                                model: {
                                  value: _vm.detail.productName,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.detail,
                                      "productName",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "detail.productName",
                                },
                              })
                            : _c("span", { staticClass: "el-input" }, [
                                _vm._v(_vm._s(_vm.detail.productName)),
                              ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { xs: 24, sm: 12, md: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品图片", prop: "cover" } },
                        [
                          _c(
                            "div",
                            { staticClass: "image-uploader" },
                            [
                              _c(
                                "el-upload",
                                {
                                  staticClass: "avatar-uploader",
                                  attrs: {
                                    action: "#",
                                    accept: "image/*",
                                    "show-file-list": false,
                                    "on-change": _vm.imageChange.bind(null, {
                                      key: "cover",
                                    }),
                                    "http-request": _vm.imageUpload.bind(null, {
                                      key: "cover",
                                    }),
                                  },
                                },
                                [
                                  _vm.coverImage.url
                                    ? [
                                        _c("img", {
                                          staticClass: "avatar",
                                          attrs: { src: _vm.coverImage.url },
                                        }),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "el-upload-img-actions",
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "el-upload-img-preview",
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    return _vm.imagePreview({
                                                      key: "cover",
                                                    })
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-zoom-in",
                                                }),
                                              ]
                                            ),
                                            _vm.canEdit
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "el-upload-img-delete",
                                                    on: {
                                                      click: function ($event) {
                                                        $event.stopPropagation()
                                                        return _vm.imageBeforeRemove(
                                                          { key: "cover" }
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "el-icon-delete",
                                                    }),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]
                                    : _c("i", {
                                        staticClass:
                                          "el-icon-plus avatar-uploader-icon",
                                      }),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { xs: 24, sm: 12, md: 16 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品轮播图", prop: "galleries" } },
                        [
                          _c(
                            "el-upload",
                            {
                              attrs: {
                                action: "#",
                                limit: 9,
                                multiple: "",
                                accept: "image/*",
                                "list-type": "picture-card",
                                "file-list": _vm.galleries,
                                "on-change": _vm.imageChange.bind(null, {
                                  key: "galleries",
                                }),
                                "on-remove": _vm.imageRemove.bind(null, {
                                  key: "galleries",
                                }),
                                "on-preview": _vm.imagePreview.bind(null, {
                                  key: "galleries",
                                }),
                                "http-request": _vm.imageUpload.bind(null, {
                                  key: "galleries",
                                }),
                                "before-remove": _vm.imageBeforeRemove.bind(
                                  null,
                                  { key: "galleries" }
                                ),
                              },
                            },
                            [_c("i", { staticClass: "el-icon-plus" })]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.canEdit
                ? _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { xs: 24, sm: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "inline-form-item",
                              attrs: { label: "上架" },
                            },
                            [
                              _c("el-switch", {
                                staticClass: "rectangle",
                                attrs: {
                                  width: 60,
                                  "active-color": "#13ce66",
                                  "active-value": 1,
                                  "inactive-value": 0,
                                },
                                model: {
                                  value: _vm.detail.isOnsale,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.detail, "isOnsale", $$v)
                                  },
                                  expression: "detail.isOnsale",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { xs: 24, sm: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "inline-form-item",
                              attrs: { label: "是否审核" },
                            },
                            [
                              _c("el-switch", {
                                staticClass: "rectangle",
                                attrs: {
                                  width: 60,
                                  "active-color": "#13ce66",
                                  "active-value": 1,
                                  "inactive-value": 0,
                                },
                                model: {
                                  value: _vm.detail.status,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.detail, "status", $$v)
                                  },
                                  expression: "detail.status",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-collapse-item",
            { attrs: { title: "商品价格", name: "Prices" } },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { xs: 24, sm: 12, md: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "inline-form-item",
                          attrs: { label: "供货价", prop: "stockPrice" },
                        },
                        [
                          _vm.canEdit
                            ? _c(
                                "el-input",
                                {
                                  staticClass: "max-width",
                                  attrs: {
                                    type: "number",
                                    placeholder: "供货价",
                                  },
                                  model: {
                                    value: _vm.detail.stockPrice,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.detail, "stockPrice", $$v)
                                    },
                                    expression: "detail.stockPrice",
                                  },
                                },
                                [
                                  _c("template", { slot: "append" }, [
                                    _vm._v("元"),
                                  ]),
                                ],
                                2
                              )
                            : _c(
                                "span",
                                { staticClass: "el-input max-width" },
                                [_vm._v(_vm._s(_vm.detail.stockPrice))]
                              ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { xs: 24, sm: 12, md: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "inline-form-item",
                          attrs: { label: "成本价", prop: "costPrice" },
                        },
                        [
                          _vm.canEdit
                            ? _c(
                                "el-input",
                                {
                                  staticClass: "max-width",
                                  attrs: {
                                    type: "number",
                                    placeholder: "成本价",
                                  },
                                  model: {
                                    value: _vm.detail.costPrice,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.detail, "costPrice", $$v)
                                    },
                                    expression: "detail.costPrice",
                                  },
                                },
                                [
                                  _c("template", { slot: "append" }, [
                                    _vm._v("元"),
                                  ]),
                                ],
                                2
                              )
                            : _c(
                                "span",
                                { staticClass: "el-input max-width" },
                                [_vm._v(_vm._s(_vm.detail.costPrice))]
                              ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { xs: 24, sm: 12, md: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "inline-form-item",
                          attrs: { label: "零售价", prop: "retailPrice" },
                        },
                        [
                          _vm.canEdit
                            ? _c(
                                "el-input",
                                {
                                  staticClass: "max-width",
                                  attrs: {
                                    type: "number",
                                    placeholder: "零售价",
                                  },
                                  model: {
                                    value: _vm.detail.retailPrice,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.detail, "retailPrice", $$v)
                                    },
                                    expression: "detail.retailPrice",
                                  },
                                },
                                [
                                  _c("template", { slot: "append" }, [
                                    _vm._v("元"),
                                  ]),
                                ],
                                2
                              )
                            : _c(
                                "span",
                                { staticClass: "el-input max-width" },
                                [_vm._v(_vm._s(_vm.detail.retailPrice))]
                              ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { xs: 24, sm: 12, md: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "inline-form-item price-type",
                          attrs: { label: "会员价类型" },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "max-width",
                              attrs: { placeholder: "请选择会员价类型" },
                              on: { change: _vm.priceTypeChange },
                              model: {
                                value: _vm.detail.priceType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.detail, "priceType", $$v)
                                },
                                expression: "detail.priceType",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { value: 0, label: "纯现金" },
                              }),
                              _c("el-option", {
                                attrs: { value: 1, label: "纯积分" },
                              }),
                              _c("el-option", {
                                attrs: { value: 2, label: "现金+积分" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.detail.priceType === 2
                    ? _c(
                        "el-col",
                        { attrs: { xs: 24, sm: 12, md: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "inline-form-item",
                              attrs: { label: "会员价", prop: "pointPrice" },
                            },
                            [
                              _vm.canEdit
                                ? _c(
                                    "el-input",
                                    {
                                      staticClass: "max-width",
                                      attrs: {
                                        type: "number",
                                        placeholder: "会员价",
                                      },
                                      model: {
                                        value: _vm.detail.pointPrice,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.detail,
                                            "pointPrice",
                                            $$v
                                          )
                                        },
                                        expression: "detail.pointPrice",
                                      },
                                    },
                                    [
                                      _c("template", { slot: "append" }, [
                                        _vm._v("元"),
                                      ]),
                                    ],
                                    2
                                  )
                                : _c(
                                    "span",
                                    { staticClass: "el-input max-width" },
                                    [_vm._v(_vm._s(_vm.detail.pointPrice))]
                                  ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.detail.priceType !== 0
                    ? _c(
                        "el-col",
                        { attrs: { xs: 24, sm: 12, md: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "inline-form-item",
                              attrs: { label: "抵扣积分", prop: "point" },
                            },
                            [
                              _vm.canEdit
                                ? _c(
                                    "el-input",
                                    {
                                      staticClass: "max-width",
                                      attrs: {
                                        type: "number",
                                        placeholder: "抵扣积分",
                                      },
                                      model: {
                                        value: _vm.detail.point,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.detail, "point", $$v)
                                        },
                                        expression: "detail.point",
                                      },
                                    },
                                    [
                                      _c("template", { slot: "append" }, [
                                        _vm._v("积分"),
                                      ]),
                                    ],
                                    2
                                  )
                                : _c(
                                    "span",
                                    { staticClass: "el-input max-width" },
                                    [_vm._v(_vm._s(_vm.detail.point))]
                                  ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-col",
                    { attrs: { xs: 24, sm: 12, md: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "inline-form-item",
                          attrs: { label: "库存", prop: "quantity" },
                        },
                        [
                          _vm.canEdit
                            ? _c("el-input", {
                                staticClass: "max-width",
                                attrs: {
                                  type: "number",
                                  placeholder: "请输入库存",
                                },
                                model: {
                                  value: _vm.detail.quantity,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.detail, "quantity", $$v)
                                  },
                                  expression: "detail.quantity",
                                },
                              })
                            : _c(
                                "span",
                                { staticClass: "el-input max-width" },
                                [_vm._v(_vm._s(_vm.detail.quantity))]
                              ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.detail.priceType !== 1
                    ? _c(
                        "el-col",
                        { attrs: { xs: 24, sm: 12, md: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "inline-form-item",
                              attrs: { label: "惊喜倍数", prop: "surprise" },
                            },
                            [
                              _vm.canEdit
                                ? _c("el-input", {
                                    staticClass: "max-width",
                                    attrs: {
                                      type: "number",
                                      placeholder: "请输入惊喜值倍数",
                                    },
                                    model: {
                                      value: _vm.detail.surprise,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.detail, "surprise", $$v)
                                      },
                                      expression: "detail.surprise",
                                    },
                                  })
                                : _c(
                                    "span",
                                    { staticClass: "el-input max-width" },
                                    [_vm._v(_vm._s(_vm.detail.surprise))]
                                  ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-collapse-item",
            { attrs: { title: "商品介绍", name: "Introduction" } },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "planText" } },
                        [
                          _c("my-editor", {
                            attrs: {
                              text: _vm.detail.planText,
                              images: _vm.editorImages,
                              "auto-focus": false,
                              "read-only": !_vm.canEdit,
                            },
                            on: {
                              "update:text": function ($event) {
                                return _vm.$set(_vm.detail, "planText", $event)
                              },
                              "update:images": function ($event) {
                                _vm.editorImages = $event
                              },
                              change: _vm.editorChange,
                            },
                            model: {
                              value: _vm.detail.intro,
                              callback: function ($$v) {
                                _vm.$set(_vm.detail, "intro", $$v)
                              },
                              expression: "detail.intro",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("el-image", {
        ref: "elImage",
        staticStyle: { width: "0", height: "0" },
        attrs: { src: _vm.previewImg, "preview-src-list": _vm.previewList },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }